module.exports = __webpack_public_path__ + "assets/shape.59e8df04809a7d399c96f2b89a075d30.png";